module.exports = __webpack_public_path__ + "static/media/hu.4707577f.svg";